/* eslint-disable camelcase */
/* eslint-disable no-underscore-dangle */
import React, { Component } from "react";
import { connect } from "react-redux";
import { I18n } from "react-redux-i18n";
import Button from "@alboompro/boom-components/general/button";
import Icon from "@alboompro/boom-components/general/icon";
import PageSelect from "editor/components/PageSelect";
import {
  handleStatusDropdown,
  handleModal,
  requestCreate,
} from "store/actions/headerActions";

import LastSaved from "./LastSaved";
import PublishButton from "./PublishButton";
import UpgradeButton from "./UpgradeButton";
import PageSettings from "./PageSettings";

import {
  MainHeaderContainer,
  HeaderLeft,
  HeaderCenter,
  HeaderRight,
  Logo,
  EditorTitle,
  ButtonContainer,
  HistoryContainer,
  LoadingContainer,
  ButtonWrapperTooltip,
  TooltipWrapper,
  Tooltip,
} from "./styles";

import { Loading } from "./icons";

const UndoRedoActions = () => (
  <HistoryContainer>
    <Icon
      kind="bold"
      group="interface-essential"
      category="text-options"
      file="undo.svg"
      size="18"
      color="#B5B5B5"
    />
    <Icon
      kind="bold"
      group="interface-essential"
      category="text-options"
      file="redo.svg"
      size="18"
      color="#B5B5B5"
    />
  </HistoryContainer>
);

// const PageStatus = ({ show, onClick, pageStatus }) => (
//   <PageStatusContent status={pageStatus} onClick={onClick} show={show}>
//     <div>{pageStatus === "publish" ? "Online" : "Offline"}</div>
//     {show && <PageStatusList />}
//   </PageStatusContent>
// );

// {
//   !requestStatusPending ? (
//     <ButtonWrapperTooltip>
//       <PageStatus
//         pageStatus={page.status}
//         show={pageStatusDropdown}
//         onClick={() => handleStatusDropdown(!pageStatusDropdown)}
//       />
//       <TooltipWrapper off={pageStatusDropdown}>
//         <Tooltip>
//           {I18n.t("header.pageStatus.tooltip.title")}
//           <span>{I18n.t("header.pageStatus.tooltip.details")}</span>
//         </Tooltip>
//       </TooltipWrapper>
//     </ButtonWrapperTooltip>
//   ) : (
//     <LoadingContainer>
//       <Loading />
//     </LoadingContainer>
//   )
// }

// const PageSelect = ({ show, onClick, pageName }) => (
//   <PageSelectContent onClick={onClick} show={show}>
//     <span>{I18n.t("header.pageSelect.page")}</span>
//     <div>
//       <PageName>{pageName}</PageName>
//     </div>
//     {show && <PageSelectList />}
//   </PageSelectContent>
// );

// const ModalCreate = ({
//   pageModal,
//   handleModal,
//   handleChange,
//   name,
//   handleCreate,
//   requestCreatePending
// }) => (
//   <Modal
//     title={I18n.t("header.newPage.modal.title")}
//     visible={pageModal}
//     onClose={handleModal}
//     bodyStyle={{ backgroundColor: "#f8f8f8" }}
//     backdropStyle={{ backgroundColor: "rgba(120, 120, 120, 0.9)" }}
//     footer={
//       <FooterContent>
//         <Button onClick={handleModal}>{I18n.t("general.cancel")}</Button>
//         <Button
//           onClick={handleCreate}
//           type="primary"
//           loading={requestCreatePending}
//         >
//           {I18n.t("header.newPage.modal.confirm")}
//         </Button>
//       </FooterContent>
//     }
//   >
//     <ModalContent>
//       <LabelPageCreate>
//         {I18n.t("header.newPage.modal.pageName")}
//       </LabelPageCreate>
//       <InputPageNameCreate
//         type="text"
//         name="page_name"
//         value={name}
//         onChange={handleChange}
//         placeholder={I18n.t("header.newPage.modal.pageNamePlaceholder")}
//       />
//     </ModalContent>
//   </Modal>
// );

class MainHeader extends Component {
  constructor() {
    super();

    this.state = {
      pageSelectDropdown: false,
      pageSettings: false,
      name: "",
    };
  }

  //   <LeaveEditorButton
  //   onClick={() => {
  //     window.location.href =
  //       "https://prosite.alboompro.com/content/custom_pages";
  //   }}
  // >
  //   <img
  //     src="http://icons.alboompro.com/v1/bold/interface-essential/login-logout/000000/login-1-alternate.svg"
  //     height="17"
  //     alt=""
  //   />
  //   {I18n.t("header.leave")}
  // </LeaveEditorButton>

  render() {
    const { pageSelectDropdown, pageSettings, name } = this.state;
    const {
      page,
      pageStatusDropdown,
      handleStatusDropdown,
      pageModal,
      handleModal,
      requestStatusPending,
      requestCreatePending,
      requestShowPending,
      requestCreate,
    } = this.props;

    let targetUrl = `${page.domain}${page.slug}`;
    if (page?.page_content?._id) {
      targetUrl = targetUrl.concat(`/?id=${page.page_content._id}`);
    }
    return (
      <MainHeaderContainer>
        <HeaderLeft>
          <Logo>
            <img
              src="https://storage.alboompro.com/products/v2/alboom_prosite.svg"
              alt=""
            />
          </Logo>
          <EditorTitle>{I18n.t("header.title")}</EditorTitle>
          <LastSaved />
        </HeaderLeft>
        <HeaderCenter>
          {!requestShowPending ? (
            <PageSelect pageName={page.name} />
          ) : (
            <LoadingContainer>
              <Loading />
            </LoadingContainer>
          )}
        </HeaderCenter>
        <HeaderRight>
          <ButtonWrapperTooltip>
            <PageSettings />
            <TooltipWrapper>
              <Tooltip>
                {I18n.t("header.pageSettings.tooltip.title")}
                <span>{I18n.t("header.pageSettings.tooltip.details")}</span>
              </Tooltip>
            </TooltipWrapper>
          </ButtonWrapperTooltip>
          {/* <UndoRedoActions /> */}
          <ButtonContainer>
            <ButtonWrapperTooltip>
              <Button
                onClick={() => {
                  if (process.env.NODE_ENV === "development") {
                    targetUrl = targetUrl.concat("&boom_staging=true");
                  }
                  window.open(targetUrl, "_blank");
                }}
                style={{ backgroundColor: "transparent", padding: "0 20px" }}
                icon={
                  <img
                    src="https://icons.alboompro.com/v1/bold/interface-essential/view/4F4F4F/view-1.svg"
                    width="17"
                    height="17"
                  />
                }
                iconStyle={{ marginRight: "10px" }}
              >
                <span style={{ fontSize: 14 }}>{I18n.t("header.preview.button")}</span>
              </Button>
              <TooltipWrapper>
                <Tooltip>
                  {I18n.t("header.preview.tooltip.title")}
                  <span>{I18n.t("header.preview.tooltip.details")}</span>
                </Tooltip>
              </TooltipWrapper>
            </ButtonWrapperTooltip>
            <ButtonWrapperTooltip>
              <PublishButton />
              <TooltipWrapper>
                <Tooltip>
                  {I18n.t("header.publish.tooltip.title")}
                  <span>{I18n.t("header.publish.tooltip.details")}</span>
                  <a
                    href={`${page.domain}${page.slug}`}
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    {I18n.t("header.publish.tooltip.link")}
                  </a>
                </Tooltip>
              </TooltipWrapper>
            </ButtonWrapperTooltip>
            <UpgradeButton text={I18n.t("header.upgrade.button")} />
          </ButtonContainer>
          {/* <ModalCreate
            pageModal={pageModal}
            name={name}
            handleChange={e => this.setState({ name: e.target.value })}
            handleModal={() => {
              handleModal(!pageModal);
              this.setState({ name: "" });
            }}
            handleCreate={() => requestCreate({ name })}
            requestCreatePending={requestCreatePending}
          /> */}
        </HeaderRight>
      </MainHeaderContainer>
    );
  }
}

const mapDispatchToProps = {
  handleStatusDropdown,
  handleModal,
  requestCreate,
};

const mapStateToProps = (state) => {
  return {
    page: state.page,
    requestStatusPending: state.header.requestPending === "status",
    requestCreatePending: state.header.requestPending === "create",
    requestShowPending: state.header.requestPending === "show",
    pageStatusDropdown: state.header.pageStatusDropdown,
    pageModal: state.header.pageModal,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MainHeader);
